<div class="cpcontent googlesignin" [hidden]="isAuthenticatedWithFirebase">
  <h5>Signin with Google to access the Firebase database</h5>
  <br>
  <div class="row">
      <div class="col-md-6">
          <button class="btn btn-primary" (click)="signInWithGoogle()">Sign in with Google</button>
      </div>
  </div>
</div>
<div class="cpcontent" [hidden]="!isAuthenticatedWithFirebase">
  <h1 style="display:inline-block"> Show Textures</h1>
  <br>
  <ul class="nav nav-tabs" id="myTab2" role="tablist">
    <li class="nav-item" role="presentation">
      <a class="nav-link active" id="ground-tab" data-bs-toggle="tab" href="#ground" role="tab" aria-controls="ground" aria-selected="true">Grounds</a>
    </li>
    <li class="nav-item" role="presentation">
      <a class="nav-link" id="skybox-tab" data-bs-toggle="tab" href="#skybox" role="tab" aria-controls="skybox" aria-selected="true">Skyboxes</a>
    </li>
    <li class="nav-item" role="presentation">
      <a class="nav-link" id="pics-tab" data-bs-toggle="tab" href="#pics" role="tab" aria-controls="pics" aria-selected="true">Pictures</a>
    </li>
    <li class="nav-item" role="presentation">
      <a class="nav-link" id="groundheight-tab" data-bs-toggle="tab" href="#groundheight" role="tab" aria-controls="groundheight" aria-selected="false">Ground Heights</a>
    </li>

  </ul>

  <!-- Content of  Tabs -------------------------------------------------------------------------->
  <div class="tab-content" id="myTab2Content">
    <!-- Ground -------------------------------------------------------------------------->
    <div class="tab-pane active fade show" id="ground" role="tabpanel" aria-labelledby="header-tab">
      <h5>Ground Textures</h5>
      <div class="mb-2">
        <small class="text-muted">Path: assets/textures/ground</small>
      </div>
      <div class="image-gallery">
        <div *ngFor="let file of files_ground" class="file-item">
          <!-- Display the image if it can be previewed -->
          <img *ngIf="file.CanPreview" [src]="file.DownloadUrl" [alt]="file.Key" 
               style="cursor: pointer;" 
               (click)="openSingleImageModal(file, 'Ground Texture')" />

          <!-- Optionally, show a placeholder if the image cannot be previewed -->
          <div *ngIf="!file.CanPreview" class="placeholder">
            <p>No preview available</p>
          </div>

          <!-- Display only the filename below the image or placeholder -->
          <p>{{ getFilename(file.Key) }}</p>
        </div>
      </div>
    </div>
    <!-- Skybox -------------------------------------------------------------------------->
    <div class="tab-pane fade show" id="skybox" role="tabpanel" aria-labelledby="header-tab">
      <h5>Skybox Textures</h5>
      <div class="mb-2">
        <small class="text-muted">Path: assets/textures/skybox</small>
      </div>
      <div class="image-gallery">
        <div *ngFor="let file of files_skybox" class="file-item skybox-item">
          <!-- Display the image if it can be previewed -->
          <img *ngIf="file.CanPreview" [src]="file.DownloadUrl" [alt]="file.Key" 
               style="cursor: pointer;" 
               (click)="openSingleImageModal(file, 'Skybox Texture')" />

          <!-- Optionally, show a placeholder if the image cannot be previewed -->
          <div *ngIf="!file.CanPreview" class="placeholder">
            <p>No preview available</p>
          </div>

          <!-- Display only the filename below the image or placeholder -->
          <p>{{ getFilenameWithEnvExtension(file.Key) }}</p>
        </div>
      </div>
    </div>

    <!-- files_textures -------------------------------------------------------------------------->
    <div class="tab-pane fade show" id="pics" role="tabpanel" aria-labelledby="header-tab">
      <h5>General Pictures</h5>
      <div class="mb-2">
        <small class="text-muted">Path: assets/textures</small>
      </div>
      <!-- Wrap the images in a container -->
      <div class="image-gallery">
        <div *ngFor="let file of files_textures" class="file-item">
          <!-- Display the image if it can be previewed -->
          <img *ngIf="file.CanPreview" [src]="file.DownloadUrl" [alt]="file.Key" 
               style="cursor: pointer;" 
               (click)="openSingleImageModal(file, 'Picture')" />

          <!-- Optionally, show a placeholder if the image cannot be previewed -->
          <div *ngIf="!file.CanPreview" class="placeholder">
            <p>No preview available</p>
          </div>

          <!-- Display only the filename below the image or placeholder -->
          <p>{{ getFilename(file.Key) }}</p>
        </div>
      </div>


    </div>

    <!-- Ground Height -------------------------------------------------------------------------->
    <div class="tab-pane fade show" id="groundheight" role="tabpanel" aria-labelledby="groundheight-tab">
      <h5>Ground Height Maps</h5>
      <div class="mb-2">
        <small class="text-muted">Path: assets/textures/groundheight</small>
      </div>
      <div class="image-gallery">
        <div *ngFor="let file of files_groundHeight" class="file-item">
          <!-- Display the image if it can be previewed -->
          <img *ngIf="file.CanPreview" [src]="file.DownloadUrl" [alt]="file.Key" 
               style="cursor: pointer;" 
               (click)="openSingleImageModal(file, 'Ground Height Map')" />

          <!-- Optionally, show a placeholder if the image cannot be previewed -->
          <div *ngIf="!file.CanPreview" class="placeholder">
            <p>No preview available</p>
          </div>

          <!-- Display only the filename below the image or placeholder -->
          <p>{{ getFilename(file.Key) }}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal for large skybox display -->
<div *ngIf="showSkyboxModal" class="cpmodal" style="z-index: 1060;" (click)="closeSkyboxModal()">
  <div class="cpmodal-content" style="max-width: 95vw; max-height: 95vh;" (click)="$event.stopPropagation()">
    <div class="cpmodal-header d-flex justify-content-between align-items-center">
      <h5 class="mb-0">{{ selectedSkyboxGroup?.folderName || 'Skybox' }}</h5>
      <button type="button" class="btn-close" (click)="closeSkyboxModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="cpmodal-body text-center p-3">
      <div *ngIf="selectedSkyboxGroup" class="skybox-modal-grid">
        <!-- Positive Z (_pz) on top -->
        <div class="skybox-modal-cell pz">
          <img *ngIf="selectedSkyboxGroup.images['_pz']" 
               [src]="selectedSkyboxGroup.images['_pz'].DownloadUrl" 
               [alt]="selectedSkyboxGroup.images['_pz'].Key" 
               class="img-fluid skybox-modal-image" />
          <div class="skybox-label">+Z</div>
        </div>
        <!-- Middle row -->
        <div class="skybox-modal-cell nx">
          <img *ngIf="selectedSkyboxGroup.images['_nx']" 
               [src]="selectedSkyboxGroup.images['_nx'].DownloadUrl" 
               [alt]="selectedSkyboxGroup.images['_nx'].Key" 
               class="img-fluid skybox-modal-image" />
          <div class="skybox-label">-X</div>
        </div>
        <div class="skybox-modal-cell py">
          <img *ngIf="selectedSkyboxGroup.images['_py']" 
               [src]="selectedSkyboxGroup.images['_py'].DownloadUrl" 
               [alt]="selectedSkyboxGroup.images['_py'].Key" 
               class="img-fluid skybox-modal-image" />
          <div class="skybox-label">+Y</div>
        </div>
        <div class="skybox-modal-cell px">
          <img *ngIf="selectedSkyboxGroup.images['_px']" 
               [src]="selectedSkyboxGroup.images['_px'].DownloadUrl" 
               [alt]="selectedSkyboxGroup.images['_px'].Key" 
               class="img-fluid skybox-modal-image" />
          <div class="skybox-label">+X</div>
        </div>
        <div class="skybox-modal-cell ny">
          <img *ngIf="selectedSkyboxGroup.images['_ny']" 
               [src]="selectedSkyboxGroup.images['_ny'].DownloadUrl" 
               [alt]="selectedSkyboxGroup.images['_ny'].Key" 
               class="img-fluid skybox-modal-image" />
          <div class="skybox-label">-Y</div>
        </div>
        <!-- Negative Z (_nz) at the bottom -->
        <div class="skybox-modal-cell nz">
          <img *ngIf="selectedSkyboxGroup.images['_nz']" 
               [src]="selectedSkyboxGroup.images['_nz'].DownloadUrl" 
               [alt]="selectedSkyboxGroup.images['_nz'].Key" 
               class="img-fluid skybox-modal-image" />
          <div class="skybox-label">-Z</div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal for single image display (ground textures and pictures) -->
<div *ngIf="showImageModal" class="cpmodal" style="z-index: 1060;" (click)="closeImageModal()">
  <div class="cpmodal-content" style="max-width: 90vw; max-height: 90vh;" (click)="$event.stopPropagation()">
    <div class="cpmodal-header d-flex justify-content-between align-items-center">
      <h5 class="mb-0">{{ selectedImage?.title || 'Image' }}</h5>
      <button type="button" class="btn-close" (click)="closeImageModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="cpmodal-body text-center p-3">
      <img *ngIf="selectedImage" 
           [src]="selectedImage.url" 
           [alt]="selectedImage.title"
           class="img-fluid" 
           style="max-width: 100%; max-height: 70vh; object-fit: contain;" />
    </div>
    <div class="cpmodal-footer">
      <small class="text-muted">{{ selectedImage?.filename }}</small>
    </div>
  </div>
</div>